import { useContainer } from "features/container/Feature";
import { useEditor } from "features/editor/Feature";

import type { Command } from "../types";

/**
 * @requires container context
 * @requires project context
 */
export const useRestartCommand = (): Command => {
  const [_, dispatch] = useContainer();
  const editor = useEditor();

  return {
    id: "codesandbox.instance.restart",
    section: "Instance",
    name: "Restart microVM",
    perform: () => {
      if (editor.allowedCapabilities.restartContainer) {
        dispatch({ type: "RESTART_CONTAINER" });
      }
    },
  };
};
